// extracted by mini-css-extract-plugin
export default {"verticallyCentered":"verticallyCentered__VerticallyCenteredCellContent__E6IM9","horizontallyCentered":"horizontallyCentered__VerticallyCenteredCellContent__E6IM9"};